import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  scrollArea: { maxHeight: '500px', overflowY: 'auto', marginBottom: '1rem' },
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      '& button': {
        alignSelf: 'end',
      },
    },
  },
  removedProductsContainer: {
    height: '100%',
  },
  title: {
    marginBottom: theme.spacing(3.5),
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: 'initial',
    },
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    width: 138,
    justifySelf: 'end',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3),
      width: '100%',
      height: 44,
    },
  },
}));
